<template>
  <v-autocomplete
    outlined
    dense
    class="full-width"
    hide-details
    :items="clients"
    item-text="formattedName"
    item-value="clientId"
    label="Client"
    color="brandCyan"
    v-model="clientId"
    :disabled="disabled"
    @change="updateClient"
    v-if="hasPermissionToViewClients() && clients && clients.length"
  ></v-autocomplete>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "ClientDropdown",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {},

  data: () => ({}),

  methods: {
    updateClient(e) {
      this.$emit("change", e);
    },
  },
  computed: {
    ...mapState(["clients", "userProfile", "globalClientId"]),
    ...mapGetters(["hasPermissionToViewClients"]),
    clientId: {
      get: function () {
        return this.globalClientId;
      },
      set: function (newVal) {
        this.$store.dispatch("setClientId", newVal);
      },
    },
  },
};
</script>
